import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const buttonStyles = ['success', 'primary', 'default'];

function ExternalButton(props) {
  let { to, text, buttonStyle, preview, children, ...otherProps } = props;
  if (!to || (!text && !children)) {
    return null;
  }
  if (buttonStyles.indexOf(buttonStyle) < 0) {
    buttonStyle = buttonStyles[0];
  }

  if (
    preview ||
    to.startsWith('http://') ||
    to.startsWith('https://') ||
    to.startsWith('//') ||
    to.startsWith('mailto:') ||
    to.startsWith('tel:')
  ) {
    return (
      <a href={to} className={`btn btn-${buttonStyle}`} target="_blank">
        {text}
        {children}
      </a>
    );
  } else if (to.startsWith('/')) {
    return (
      <Link to={to} className={`btn btn-${buttonStyle}`} {...otherProps}>
        {text}
        {children}
      </Link>
    );
  } else {
    return null;
  }
}

ExternalButton.propTypes = {
  to: PropTypes.string,
  text: PropTypes.string,
  buttonStyle: PropTypes.string,
  children: PropTypes.any
};

export default ExternalButton;



// WEBPACK FOOTER //
// ./src/components/ExternalButton/index.js